import { useLazyQuery } from "@apollo/client";
import { clientNeoFact } from "@neonumy/api-clients";
import dayjs from "dayjs";
import { GET_COMPANY_INVOICE_DESIGN_UPDATED_DATE } from "queries/neoFact/templates";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function useInvoiceTemplateModal() {
  const { companyId } = useParams();
  const [isTemplateModal, setIsTemplateModal] = useState(false);

  const [getInvoiceDesignUpdatedDate] = useLazyQuery<
    GetCompanySaleDocumentDesignResponse,
    GetCompanySaleDocumentDesignVars
  >(GET_COMPANY_INVOICE_DESIGN_UPDATED_DATE, {
    client: clientNeoFact,
  });

  const checkTemplateDesign = () => {
    getInvoiceDesignUpdatedDate({ variables: { companyId } }).then(({ data }) => {
      if (data?.getCompanySaleDocumentDesign?.updatedAt) {
        const updatedDateIsAfterDeploy = dayjs(
          data?.getCompanySaleDocumentDesign?.updatedAt,
        ).isAfter("2025-11-15");

        if (!updatedDateIsAfterDeploy) {
          setIsTemplateModal(true);
        }
      } else {
        setIsTemplateModal(true);
      }
    });
  };

  const closeTemplateModal = () => {
    setIsTemplateModal(false);
  };

  useEffect(() => {
    checkTemplateDesign();
  }, [companyId]);

  return {
    isTemplateModal,
    closeTemplateModal,
  };
}
